import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, Router } from '@angular/router';
import { BrMaskerModule } from 'br-mask';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HttpHeaders, HTTP_INTERCEPTORS} from '@angular/common/http';
import {NgxMaskIonicModule} from 'ngx-mask-ionic'
import { IonicStorageModule } from '@ionic/storage';
import { AuthInterceptor } from  './_helpers/authInterceptor';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { FileTransfer } from "@ionic-native/file-transfer/ngx";
import { environment } from 'src/environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
import { StompService } from './services/stomp.service';
//import { BackgroundMode } from '@awesome-cordova-plugins/background-mode/ngx';
//import { NgXCreditCardsModule } from 'ngx-credit-cards';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    BrMaskerModule,
    //NgXCreditCardsModule,
    //FirebaseX,
    NgxMaskIonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    FirebaseX,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy, },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    { provide:  StompService},
    File,
    FileOpener,
    FileTransfer,
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {

  constructor(public router : Router) {}
//archivos generados el dia 11/11/2022  prod

  //API KEY GOOGLE MAPS
  key = "AIzaSyAyvoyQrm1qCaERFLpBMoxRVSes_37r9CE";

  // url qa interna
  //url = 'http://192.168.4.39';

  // url qa externa
  //url = 'https://dhm.grupogd.com.sv:6381';

  // url produccion
  url = 'https://dhm.prepapp.biz';

  //Local Web
   //host = 'http://localhost:8080/dhm/';   

  //produccion
  host =  'https://dhm.prepapp.biz/dhm/';

  //QA interno
  //host =  'http://192.168.4.39:8080/dhm/';

  //QA externo
  //host =  'https://dhm.grupogd.com.sv:6383/dhm/'


  //Array de ordenes
  orders = [];

  pkGeneralConfig = 3;

  //Max Sise: 2MB
  maxFileSize=2e6;
  maxFileSizeLogo =200000;

  //Closest location
  closestLocationKey = 0;

  //Selected order in recent or favorite
  pkSelectedTicket = "";

  //badge carrito
  badgeOrdenes: number;
  routingTabHome(){
    this.router.navigateByUrl("/menu/home");
  }

  routingTabOrder(){
    this.router.navigateByUrl("/order/confirm");
  }

  routingTabActiveOrder(){
    this.router.navigateByUrl('/active-order');
  }

  fixedNumbers(num){
    return parseFloat(num).toFixed(2);
  }
}
